import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {inject, onMounted, ref} from "vue";
import {IconName} from "../Icon/icons";
import TextInput from "./TextInput.vue";
import TextInputOutline from "./TextInputOutline.vue";

interface Props {
  placeholder: string;
  testId?: string;
  nested?: boolean;
  disabled?: boolean;
  formatHtml?: boolean;
  icon?: IconName;
  gainFocus?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TextField',
  props: /*@__PURE__*/_mergeModels({
    placeholder: {},
    testId: {},
    nested: { type: Boolean },
    disabled: { type: Boolean },
    formatHtml: { type: Boolean },
    icon: {},
    gainFocus: { type: Boolean }
  }, {
    "modelValue": {default: ''},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose }) {

const text = _useModel<string>(__props, "modelValue");
const props = __props;
const fieldLabelId = inject<string|undefined>('fieldLabelId', undefined);

const input = ref<HTMLInputElement>();

onMounted(() => {
  if (props.gainFocus) {
    input.value!.focus({preventScroll: true});
  }
});

function focus(options?: FocusOptions): void {
  input.value!.focus({preventScroll: true});
}

__expose({focus});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TextInputOutline, {
    disabled: props.disabled,
    icon: props.icon,
    nested: props.nested
  }, {
    default: _withCtx(() => [
      _createVNode(TextInput, {
        ref_key: "input",
        ref: input,
        class: "outline-none flex-grow-1",
        type: props.formatHtml ? 'html' : 'plain',
        "label-id": _unref(fieldLabelId),
        "test-id": props.testId,
        placeholder: props.placeholder,
        disabled: _ctx.disabled,
        modelValue: text.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event))
      }, null, 8 /* PROPS */, ["type", "label-id", "test-id", "placeholder", "disabled", "modelValue"]),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["disabled", "icon", "nested"]))
}
}

})